import { render, staticRenderFns } from "./choice-question-component.vue?vue&type=template&id=2d031c22&scoped=true&"
import script from "./choice-question-component.vue?vue&type=script&lang=ts&"
export * from "./choice-question-component.vue?vue&type=script&lang=ts&"
import style0 from "./choice-question-component.vue?vue&type=style&index=0&id=2d031c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d031c22",
  null
  
)

export default component.exports